import createMainStore from '../../../common/stores/storeFactory';
import OrderViewerApiService from '../api/orderViewerApiService';
import { IOrderViewerViewModel } from '../typing/orderViewerViewModel';
import { IOrderViewerMainStore } from '../typing/stores';
import RedirectHelper from '../utils/redirectHelper';
import OrderViewerStore from './orderViewerStore';

export default function createStore(basePath: string, viewModel: IOrderViewerViewModel): IOrderViewerMainStore {
	const orderViewerStore = new OrderViewerStore(viewModel);
	const orderViewerApiService = new OrderViewerApiService(basePath);
	const redirectHelper = new RedirectHelper(viewModel.documentLogonViewerUrl?.viewerUrl);

	return {
		...createMainStore(basePath),
		orderViewerStore,
		redirectHelper,
		api: {
			orderViewerApiService: orderViewerApiService
		}
	};
}
